// ----------------------------------------------------------------------

const MuiStack = {
  defaultProps: { useFlexGap: true },
  styleOverrides: {},
};

// ----------------------------------------------------------------------

export const stack = { MuiStack };
